// extracted by mini-css-extract-plugin
module.exports = {"Tags":"styles-module--Tags--fzPIM","Tag":"styles-module--Tag--2BlKD","SelectedTag":"styles-module--SelectedTag--3_bhG"};